import { create } from "zustand";
import { addEvent } from "./api_layer";
import { ENV } from "../../config/env";
import secureLocalStorage from "react-secure-storage";

// Standard event payload with the logged-in user's identity fields
export const buildEventPayload = (event, case_id) => ({
  event,
  email: secureLocalStorage.getItem("email"),
  first_name: secureLocalStorage.getItem("first_name"),
  user_id: secureLocalStorage.getItem("id"),
  role_id: secureLocalStorage.getItem("role"),
  team: secureLocalStorage.getItem("team"),
  designation: secureLocalStorage.getItem("designation"),
  case_id,
});

export const useAddEvent = create((set) => ({
  error: null,
  // options.allEnvs: also send outside prod (default is prod-only)
  addEventData: async (payload, options = {}) => {
    try {
      if(payload?.email && payload?.first_name && payload?.user_id){
        if(ENV === 'prod' || options.allEnvs){
          await addEvent(payload);
        }
      } else {
        console.error("Missing required user information");
      }
      set({ error: null });
    } catch (error) {
      console.error(error);
      set({ error: error.message });
    }
  },
}));